<template>
  <v-img
  v-if="data && data.Image"
  :style="{ 'width': isSimulation ? '375px' : `${sizeW}px !important`}"
  :src="data.Image"
  />
</template>

 <script>
  import constants from '@/constants'
  import utils from '@/services/utils'
  export default {
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
    },
    computed: {
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      sizeW () {
        return window.innerWidth - (!utils.isMobile() ? 360 : 0)
      }
    }
  }
</script>
